import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  PlusIcon,
  Typography
} from "@dealer-center/core-components";
import { FranchiseList } from "./FranchiseList";

export const PagesFranchiseManagementUiDisplay = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCreateFranchise = () => {
    navigate("add");
  };

  useEffect(() => {
    document.title = "Franchise Management";
  }, []);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          mb: 4
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
          <Typography variant={"h1"}>Franchise Manager</Typography>
          <Typography variant={"body-md"}>
            Manage automotive franchise information and track changes
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "flex-start",
            mt: { xs: 2, md: 0 }
          }}
        >
          <Button
            analyticsConfiguration={{
              eventName: "PagesFranchiseManagementUi Create New Franchise"
            }}
            buttonStyle="primary"
            disabled={location.pathname.includes("franchiseManagement/add")}
            startIcon={<PlusIcon title="Add Franchise" />}
            onClick={handleCreateFranchise}
          >
            Create New Franchise
          </Button>
        </Box>
      </Box>
      <Box sx={{ mb: 4 }}>
        <Outlet />
      </Box>

      <Box>
        <FranchiseList />
      </Box>
    </Box>
  );
};
